module.exports = __webpack_public_path__ + "static/media/done.c6d0db73.png";